/* eslint-disable no-console */
// BonBoZ: tình trạng nhận thông báo trên ĐIỆN THOẠI của người đang đăng nhập,
// do server tổng hợp (`GET /api/v1/profile/push_health`).
//
// Một trạng thái dùng chung cho mọi banner; banner nào hiện do
// `pushBanner.js` quyết.
import { ref } from 'vue';
import PushHealthAPI from '../api/bonboz/pushHealth';
import auth from '../api/auth';

export const HEALTH_REFRESH_INTERVAL_MS = 30 * 1000;

// `{ status, last_received_at, has_phone_subscription }`, null khi chưa tải.
export const pushHealth = ref(null);

let lastFetchAt = 0;
let pendingFetch = null;

// Bỏ qua nếu lần tải trước chưa quá 30 giây; `force` dùng sau thao tác bật/tắt.
// Lỗi mạng giữ nguyên trạng thái cũ.
export const refreshPushHealth = async ({ force = false } = {}) => {
  if (!auth.hasAuthCookie()) return pushHealth.value;
  if (pendingFetch && !force) return pendingFetch;
  const now = Date.now();
  if (!force && now - lastFetchAt < HEALTH_REFRESH_INTERVAL_MS) {
    return pushHealth.value;
  }
  lastFetchAt = now;

  const request = PushHealthAPI.show()
    .then(({ data }) => {
      pushHealth.value = data;
      return data;
    })
    .catch(error => {
      console.warn('Push health check failed:', error);
      return pushHealth.value;
    })
    .finally(() => {
      if (pendingFetch === request) pendingFetch = null;
    });
  pendingFetch = request;
  return request;
};
